export default {
    information: {
        content1Content:
            '見積書や請求書をはじめ、日々の経理業務に必要な書類を作成できます。',
        content1Title: '9種類の書類をオンラインで作成',
        content2Content: '請求書をワンクリックで送付',
        content2Title: '取引先に合わせてメール送信と郵送代行を選択できます。',
        content3Content:
            '銀行口座の入金情報と請求書を紐付ける業務を効率化します。',
        content3Title: '入金消込も一括管理',
        header: 'MakeLeapsで請求業務をかんたんに',
        title: 'MakeLeapsで請求業務をかんたんに',
    },
    pageForm: {
        letsGetStarted: '次へ',
        registrationCode:
            '<0>招待コードをお持ちですか？</0> こちら<0>から入力してください</0>',
        subtitle:
            '30日間、無料でお試しいただけます。お試し終了後、自動的に有料プランに移行することはございません。',
        title: '無料アカウントをつくる',
    },
};
